<template>
  <div class="ui-box-item">
    <titleComponents :show.sync="show" name="服务信息"></titleComponents>
    <div class="itemInfo-detail" v-show="show">
      <div class="baseInfo-content">
        <div class="text">服务内容：{{data.tbGoodsName||'-'}}</div>
        <div class="text">医院名称：{{data.tbHospitalName||'-'}}</div>
        <div class="text width250">预约单号：{{data.tbReservationCode||'-'}}</div>
      </div>
      <div class="baseInfo-content">
        <div class="text">预定时间：{{data.tbReservationTime||'-'}}</div>
        <div class="text">完善时间：{{data.tbCompleteTime||'-'}}</div>
        <div class="text">付款时间：{{data.tbPayTime||'-'}}</div>
      </div>
      <div class="baseInfo-content">
        <div class="text">视频风格：{{data.tbSampleName||'-'}}</div>
      </div>
      <div class="baseInfo-content">
        免费视频：
        <upload :uploadSize="104" :isVideo="true" :isSee="false" :limit="1" :fileList.sync="data.tbFreeVideoPathTemp" :saveFileList.sync="data.tbFreeVideoPath" customLabel="上传视频" class="ui-box-from-saveGoods-upload"></upload>
        <upload :uploadSize="104" :isPic="true" :isSee="false" :limit="1" :fileList.sync="data.tbFreeVideoPathPhotoTemp" :saveFileList.sync="data.tbFreeVideoPathPhoto" class="ui-box-from-saveGoods-upload" customLabel="视频封面"></upload>
      </div>
      <div class="baseInfo-content">
        付费视频：
        <upload :uploadSize="104" :isVideo="true" :isSee="false" :limit="1" :fileList.sync="data.tbPaidVideoPathTemp" :saveFileList.sync="data.tbPaidVideoPath" customLabel="上传视频" class="ui-box-from-saveGoods-upload"></upload>
        <upload :uploadSize="104" :isPic="true" :isSee="false" :limit="1" :fileList.sync="data.tbPaidVideoPathPhotoTemp" :saveFileList.sync="data.tbPaidVideoPathPhoto" class="ui-box-from-saveGoods-upload" customLabel="视频封面"></upload>
      </div>
      <div class="footer">
        <el-button type="primary" @click="saveVideo">确认保存</el-button>
      </div>
    </div>
  </div>
</template>
</template>

<script>
import upload from '@/components/upload/upload.vue'
import titleComponents from '@/components/mother/title'
export default {
  name: 'serviveInfo',
  props: {
    data: {
      type: Object,
      default: () => { }
    },
  },
  data () {
    return {
      show: true
    }
  },
  created () {

  },
  computed: {

  },
  methods: {
    beforeSaveImg (form) {
      const temp = ['tbFreeVideoPath', 'tbPaidVideoPath', 'tbFreeVideoPathPhoto', 'tbPaidVideoPathPhoto']
      temp.map(i => {
        form[i] = form[i].map(j => j.url.replace(/.*?https:\/\/hyl-ymm.oss-cn-beijing.aliyuncs.com/, '')).join(',')
      })
      delete form.tbFreeVideoPathPhotoTemp
      delete form.tbPaidVideoPathPhotoTemp
      delete form.tbFreeVideoPathTemp
      delete form.tbPaidVideoPathTemp
      return form
    },
    saveVideo () {
      if (this.data.tbFreeVideoPath.length === 0) {
        this.$message.error('请先上传免费视频');
        return ''
      }
      if (this.data.tbFreeVideoPathPhoto.length === 0) {
        this.$message.error('请先上传免费视频封面');
        return ''
      }
      if (this.data.tbPaidVideoPath.length === 0) {
        this.$message.error('请先上传付费视频');
        return ''
      }
      if (this.data.tbPaidVideoPathPhoto.length === 0) {
        this.$message.error('请先上传付费视频封面');
        return ''
      }
      const { tbId, tbPaidVideoPath, tbFreeVideoPath, tbFreeVideoPathPhoto, tbPaidVideoPathPhoto } = this.beforeSaveImg(JSON.parse(JSON.stringify(this.data)))
      this.$http.post(`/reservationMovie/saveVideo`, { tbId, tbPaidVideoPath, tbFreeVideoPath, tbFreeVideoPathPhoto, tbPaidVideoPathPhoto })
        .then((res) => {
          if (res.code === 1000) {
            this.$message.success('保存成功');
          }
        });
    },
    uploadSuccess (ref) {
      this.$refs['form'].validateField(ref)
    },
  },
  components: {
    titleComponents,
    upload
  }
}
</script>

<style lang="scss" scoped>
.ui-box-item {
  margin: 20px 24px 0;
  background: rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: calc(100% - 48px);
  .itemInfo-detail {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .baseInfo-content {
      display: flex;
      align-content: center;
      margin-bottom: 25px;
      .text {
        width: 250px;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        margin-right: 60px;
        &.width250 {
          width: 250px;
        }
      }
    }
    .footer {
      margin-top: 10px;
      width: 100%;
      text-align: center;
    }
  }
}
</style>
     